"use client";

import { useEffect, useRef } from "react";

function useEffectOnce(fn: () => void) {
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) {
      return;
    }

    hasRun.current = true;

    fn();
  }, [fn]);
}

export { useEffectOnce };
